// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"480":"impressum","792":"main"}[chunkId] || chunkId) + "." + {"480":"ca73391e","792":"f79e6a66","799":"b0043edc"}[chunkId] + ".js";
};